import React, { Component } from 'react';
import DynamicClassHoc from '../../mui/misc/dynamic-class-hoc.jsx';

const OptionComponent = DynamicClassHoc('a');

export default class PayMethodOption extends Component {
  static propTypes = {
    name: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]).isRequired,
  };

  render() {
    const { name, ...props } = this.props;

    return (
      <OptionComponent {...props}>
        <span>{name}</span>
      </OptionComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/order/select/pay-method-option.jsx